export const LEFT_PANEL_MIN_WIDTH = 360;

export const LEFT_PANEL_MAX_WIDTH = ((document.body.offsetWidth - LEFT_PANEL_MIN_WIDTH) / 3) * 2;

export const LEFT_PANEL_EQL_WIDTH = 683;
